// src/RootProviders.js
import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import { SiteProvider } from './context/SiteContext'
import { AuthProvider } from './context/AuthContext'
import { LayoutProvider } from './context/LayoutContext'
import { UIProvider } from './context/UIContext'
import { FilterProvider } from './context/FilterContext'

export function RootProviders({ children }) {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <LayoutProvider>
            <UIProvider>
              <FilterProvider>
                {children}
              </FilterProvider>
            </UIProvider>
          </LayoutProvider>
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  )
}
